export enum PopupState {
    Properties = 'properties',
    AddMarker = 'addMarker',
    Delete = 'delete',
    DownloadArea = 'downloadArea',
    NoPopup = 'noPopup'
}
